import { Zap } from 'lucide-react';

const XP_ROWS = [
  { category: 'Learning',   items: [
    { action: 'Complete an exercise',   xp: '+10 XP',  icon: '⚡' },
    { action: 'Complete a full lesson', xp: '+50 XP',  icon: '📖' },
    { action: 'Complete a phase',       xp: '+200 XP', icon: '🏆' },
  ]},
  { category: 'Streaks',    items: [
    { action: 'Come back today',        xp: '+25 XP',  icon: '🔥' },
    { action: '7-day streak bonus',     xp: '+100 XP', icon: '💪' },
    { action: '30-day streak bonus',    xp: '+500 XP', icon: '🚀' },
  ]},
  { category: 'Community',  items: [
    { action: 'Vote on a skill',        xp: '+15 XP',  icon: '👍' },
    { action: 'Submit feedback',        xp: '+20 XP',  icon: '💬' },
    { action: 'Submit a skill request', xp: '+15 XP',  icon: '🎯' },
    { action: 'Report a bug',           xp: '+20 XP',  icon: '🐛' },
  ]},
  { category: 'Upgrades',   items: [
    { action: 'Upgrade to Explorer',    xp: '+500 XP',  icon: '⭐' },
    { action: 'Upgrade to Pro',         xp: '+1500 XP', icon: '💎' },
    { action: 'Switch to yearly',       xp: '+300 XP',  icon: '🎁' },
  ]},
];

const XPLegend = ({ isDark, compact = false, showHeader = true, bare = false }) => {
  const c = {
    card:       isDark ? '#1c1917' : '#ffffff',
    border:     isDark ? '#2d2825' : '#e8e4df',
    head:       isDark ? '#fafaf9' : '#1c1917',
    muted:      isDark ? '#78716c' : '#a8a29e',
    inner:      isDark ? '#151211' : '#f5f2ee',
    catColor:   isDark ? '#57534e' : '#a8a29e',
  };

  // bare=true drops the card chrome (background/border/padding) — for
  // embedding inside a page that already supplies its own card, like
  // Settings.jsx's collapsible XP panel.
  return (
    <div style={bare ? { display: 'flex', flexDirection: 'column', gap: 14 } : {
      background: c.card,
      border: `1.5px solid ${c.border}`,
      borderRadius: 16,
      padding: compact ? 16 : 20,
      display: 'flex',
      flexDirection: 'column',
      gap: 16,
    }}>
      {/* Header — suppressed via showHeader=false when an embedding page
          (e.g. Settings.jsx's collapsible XP panel) already renders its own
          clickable header/title for this content. */}
      {showHeader && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <div style={{
            width: 28, height: 28, borderRadius: 8,
            background: 'linear-gradient(135deg, #FF6B35, #ea580c)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            flexShrink: 0,
          }}>
            <Zap size={14} color="#fff" fill="#fff" />
          </div>
          <div>
            <p style={{ fontSize: 12, fontWeight: 800, color: c.head, margin: 0 }}>How to earn XP</p>
            {!compact && (
              <p style={{ fontSize: 11, color: c.muted, margin: 0 }}>Complete actions to level up your rank</p>
            )}
          </div>
        </div>
      )}

      {/* Rows */}
      {XP_ROWS.map(group => (
        <div key={group.category}>
          <p style={{
            fontSize: 10, fontWeight: 700, color: c.catColor,
            textTransform: 'uppercase', letterSpacing: '0.08em',
            margin: '0 0 8px 0',
          }}>
            {group.category}
          </p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            {group.items.map(item => (
              <div key={item.action} style={{
                display: 'flex', alignItems: 'center',
                justifyContent: 'space-between', gap: 8,
                padding: '6px 10px',
                background: c.inner,
                borderRadius: 8,
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
                  <span style={{ fontSize: 13 }}>{item.icon}</span>
                  <span style={{ fontSize: 12, color: c.head, fontWeight: 500 }}>{item.action}</span>
                </div>
                <span style={{
                  fontSize: 11, fontWeight: 800,
                  color: '#ea580c',
                  background: isDark ? 'rgba(234,88,12,0.12)' : '#fff7ed',
                  border: `1px solid ${isDark ? 'rgba(234,88,12,0.2)' : '#fed7aa'}`,
                  padding: '2px 7px', borderRadius: 6,
                  flexShrink: 0,
                }}>
                  {item.xp}
                </span>
              </div>
            ))}
          </div>
        </div>
      ))}

      {/* Footer note */}
      <p style={{ fontSize: 11, color: c.muted, textAlign: 'center', margin: 0, lineHeight: 1.5 }}>
        XP unlocks badges, rankings & rewards 🏅
      </p>
    </div>
  );
};

export default XPLegend;
